import { transformToPixels, getFocusableElements } from "../common/helpers";

const $header = document.querySelector(".js-ns-header");

const DUPLICATE_EVENTS = ["mouseover", "click"];

export const useHeaderNavigation = () => {
    let isInitiated = false;

    const nsHeaderNavigationHighlightInit = () => {
        const $navigation = $header.querySelector(".js-ns-header-navigation");

        if (!$navigation) {
            return;
        }

        try {
            const items = $navigation.querySelectorAll(
                ".ns-header-navigation__item"
            );

            const handleShowHighlight = ($item) => {
                items.forEach(($el) => {
                    if ($el === $item) {
                        $el.classList.remove("highlight-muted");

                        return;
                    }

                    $el.classList.add("highlight-muted");
                });
            };

            const handleHideHighlight = () => {
                items.forEach(($el) => {
                    $el.classList.remove("highlight-muted");
                });
            };

            items.forEach(($item) => {
                DUPLICATE_EVENTS.forEach((e) => {
                    $item.addEventListener(e, () => handleShowHighlight($item));
                });
            });

            $navigation.addEventListener("mouseleave", handleHideHighlight);
        } catch (e) {
            console.log(e);
        }
    };

    const nsHeaderMenuHighlightInit = () => {
        const $menu = $header.querySelector(".js-ns-header-menu");

        if (!$menu) {
            return;
        }

        try {
            const links = $menu.querySelectorAll(".ns-header__menu-link");

            links.forEach(($link) => {
                $link.addEventListener("mouseover", () => {
                    links.forEach(($el) => {
                        if ($el === $link) {
                            return;
                        }

                        $el.classList.add("highlight-muted");
                    });
                });

                $link.addEventListener("mouseleave", () => {
                    links.forEach(($el) =>
                        $el.classList.remove("highlight-muted")
                    );
                });
            });
        } catch (e) {
            console.log(e);
        }
    };

    const nsHeaderMegaInit = () => {
        try {
            const mega = document.querySelectorAll(".js-ns-header-mega");

            if (!mega || mega.length === 0) {
                return;
            }

            mega.forEach(($block) => {
                const $first = $block.querySelector(".ns-header-mega__first");
                const firstTabs = $first.querySelectorAll(
                    ".ns-header-mega__first-tab"
                );

                const $second = $block.querySelector(".ns-header-mega__second");
                const $secondBlock = $second.querySelector(
                    ".ns-header-mega__second > .ns-header-mega__block"
                );

                const secondLists = $second.querySelectorAll(
                    ".ns-header-mega__list--second"
                );
                const secondTabs = $second.querySelectorAll(
                    ".ns-header-mega__second-tab"
                );
                const sub = $second.querySelectorAll(".ns-header-mega__sub");

                const transformHeight = ($item) => {
                    const $secondListActive = $second.querySelector(
                        ".ns-header-mega__list--second.active"
                    );
                    const $sub = $item
                        ? $item.querySelector(".ns-header-mega__sub")
                        : null;
                    const $subBlock = $sub
                        ? $sub.querySelector(".ns-header-mega__block")
                        : null;

                    const firstHeight = $first?.clientHeight || 0;
                    const secondHeight = $secondListActive?.clientHeight || 0;
                    const subHeight = $sub?.clientHeight || 0;
                    const maxHeight = Math.max(
                        firstHeight,
                        secondHeight,
                        subHeight
                    );

                    $block.style.height = transformToPixels(maxHeight);
                    $secondBlock.style.height = transformToPixels(maxHeight);

                    if ($subBlock) {
                        $subBlock.style.height = transformToPixels(maxHeight);
                    }
                };

                transformHeight();

                const handleCloseFirst = () => {
                    firstTabs.forEach(($item) => {
                        $item.classList.remove("active");
                        $item.setAttribute("aria-expanded", "false");
                    });
                };

                const handleCloseSecond = () => {
                    secondLists.forEach(($list) => {
                        const expanded =
                            $list.querySelectorAll("[aria-expanded]");

                        $list.classList.remove("active");

                        expanded.forEach(($el) =>
                            $el.setAttribute("aria-expanded", "false")
                        );
                    });
                };

                const handleCloseSub = () => {
                    sub.forEach(($sub) => {
                        $sub.classList.remove("active");
                        $sub.setAttribute("inert", "true");
                    });
                };

                const handleCloseMenu = () => {
                    handleCloseFirst();
                    handleCloseSecond();
                    handleCloseSub();
                };

                const handleOpenTab = ($item, index, handleFocus = false) => {
                    handleCloseMenu();

                    $item.classList.add("active");
                    $item.setAttribute("aria-expanded", "true");

                    secondLists[index].classList.add("active");

                    $block.style.width = transformToPixels(540);

                    transformHeight();

                    if (handleFocus === false) {
                        return;
                    }

                    const $firstLink = secondLists[index].querySelector(
                        ".ns-header-mega__link"
                    );

                    $firstLink.focus();
                };

                const handleOpenSub = ($item, handleFocus = false) => {
                    const $sub = $item.querySelector(".ns-header-mega__sub");
                    const $button = $item.querySelector(
                        ".ns-header-mega__link"
                    );

                    $block.style.width = transformToPixels(850);

                    handleCloseSub();

                    secondTabs.forEach(($tab) => {
                        const expanded =
                            $tab.querySelectorAll("[aria-expanded]");

                        expanded.forEach(($el) =>
                            $el.setAttribute("aria-expanded", "false")
                        );
                    });

                    $button.setAttribute("aria-expanded", "true");

                    $sub.classList.add("active");
                    $sub.removeAttribute("inert");

                    transformHeight($item);

                    const $firstLink = $sub.querySelector(
                        ".ns-header-mega__link"
                    );

                    if (handleFocus === false) {
                        return;
                    }

                    // Delay because of animation
                    setTimeout(() => {
                        $firstLink.focus();
                    }, 200);
                };

                firstTabs.forEach(($item, index) => {
                    DUPLICATE_EVENTS.forEach((e) =>
                        $item.addEventListener(e, () =>
                            handleOpenTab($item, index)
                        )
                    );

                    $item.addEventListener("keydown", (e) => {
                        if (e.key !== "Enter") {
                            return;
                        }

                        handleOpenTab($item, index, true);
                    });
                });

                secondTabs.forEach(($item) => {
                    DUPLICATE_EVENTS.forEach((e) => {
                        $item.addEventListener(e, () => handleOpenSub($item));
                    });

                    $item.addEventListener("keydown", (e) => {
                        if (e.key !== "Enter") {
                            return;
                        }

                        handleOpenSub($item, true);
                    });

                    $item.addEventListener("mouseleave", () => {
                        const $sub = $item.querySelector(
                            ".ns-header-mega__sub"
                        );

                        $sub.classList.remove("active");
                        $sub.setAttribute("inert", "true");

                        $block.style.width = transformToPixels(540);

                        transformHeight();
                    });
                });
            });
        } catch (e) {
            console.log(e);
        }
    };

    const nsHeaderDropdownInit = () => {
        const $navigation = $header.querySelector(".js-ns-header-navigation");
        const expanded = $navigation.querySelectorAll("[aria-expanded]");
        const $menu = $header.querySelector(".js-ns-header-menu");
        const menuLinks = $menu.querySelectorAll(".ns-header__menu-link");

        if (!$navigation) {
            return;
        }

        try {
            const items = $navigation.querySelectorAll(
                ".ns-header-navigation__item"
            );
            const $dropdown = $navigation.querySelector(
                ".ns-header-navigation__dropdown"
            );
            const content = $dropdown.querySelectorAll(
                ".ns-header-navigation__dropdown-content"
            );

            let $activeInner = null;

            const dropAllExpanded = () => {
                expanded.forEach(($el) =>
                    $el.setAttribute("aria-expanded", "false")
                );
            };

            const handleShowDropdown = ($item, index, isFocusable = false) => {
                const offset = $item.offsetLeft;
                const offsetInPixels = transformToPixels(offset);

                content.forEach(($el) => {
                    $el.classList.remove("active");
                    $el.setAttribute("inert", "true");
                });

                $dropdown.style.transform = `translateX(${offsetInPixels})`;

                $activeInner = $dropdown.querySelector(
                    `[data-index="${index}"]`
                );

                if (!$activeInner) {
                    return;
                }

                $activeInner.classList.add("active");
                $activeInner.removeAttribute("inert");

                $dropdown.classList.add("active");

                setTimeout(() => {
                    $dropdown.classList.add("translate-transition");

                    if (isFocusable === true) {
                        const { $first } = getFocusableElements($activeInner);

                        items.forEach(($el) => {
                            $el.setAttribute("aria-expanded", "false");
                        });

                        $item.setAttribute("aria-expanded", "true");

                        if ($first) {
                            $first.focus();
                        }
                    }
                }, 200);
            };

            const handleHideDropdown = () => {
                $dropdown.classList.remove("active");
                $dropdown.classList.remove("translate-transition");

                content.forEach(($el) => {
                    $el.classList.remove("active");
                });

                dropAllExpanded();
            };

            items.forEach(($item, index) => {
                $item.addEventListener("mouseover", () =>
                    handleShowDropdown($item, index)
                );

                $item.addEventListener("click", () =>
                    handleShowDropdown($item, index, true)
                );
            });

            $navigation.addEventListener("mouseleave", handleHideDropdown);

            document.addEventListener("keydown", (e) => {
                const { key } = e;

                if (key === "Escape") {
                    handleHideDropdown();
                }
            });

            menuLinks.forEach(($link, index) => {
                $link.addEventListener("focusout", () => {
                    const notInertLinks = $menu.querySelectorAll(
                        ".ns-header__menu-link:not([inert])"
                    );

                    if (
                        $link.hasAttribute("inert") ||
                        notInertLinks.length - 1 !== index
                    ) {
                        return;
                    }

                    handleHideDropdown();
                });
            });
        } catch (e) {
            console.log(e);
        }
    };

    const init = () => {
        const windowWidth = window.innerWidth;

        if (!$header || isInitiated === true || windowWidth < 1024) {
            return;
        }

        nsHeaderMegaInit();
        nsHeaderNavigationHighlightInit();
        nsHeaderMenuHighlightInit();
        nsHeaderDropdownInit();

        isInitiated = true;
    };

    const initHeaderNavigation = () => {
        document.addEventListener("DOMContentLoaded", init);
        window.addEventListener("resize", init);
    };

    return {
        initHeaderNavigation,
    };
};
